import { render, staticRenderFns } from "./KoioteHoverFunction.vue?vue&type=template&id=2312c094"
import script from "./KoioteHoverFunction.vue?vue&type=script&lang=js"
export * from "./KoioteHoverFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports